import { Logger } from 'sierra-client/core/logging/logger'
import { AuthView } from 'sierra-client/views/authentication/flows/types'

export const authImpression = Logger.trackLogger<{
  step: AuthView
}>('auth_impression', false)
